<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Munkavállalók és riportok</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$"><br />
  <ng-container>
    <ion-grid>
      <ion-row>
        <ion-col>
          <!--  A `height: 100%` SZÁNDÉKOSAN NINCS ITT. Amíg ez volt az egyetlen kártya a
                hasábban, nem látszott a hatása; mióta alatta áll a kedvezmény-kártya, a
                hasáb magassága mindkettőt tartalmazza, és a 100% erre fújta fel ezt a
                kártyát – üres fehér sávot hagyva, a másikat pedig kiszorítva a hasábból,
                ahol a következő kártya kifestette. -->
          <ion-card>
            <ion-card-header>
              <ion-card-title><span style="vertical-align: -webkit-baseline-middle">Beállítások</span>
                <ion-button style="float: right" size="small" color="secondary" (click)="resetM()">
                  <ion-icon slot="start" name="refresh"></ion-icon>
                  Visszaállítás
                </ion-button>
              </ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-input fill="outline" labelPlacement="stacked" label="Tárgyév" type="text" inputmode="numeric"
                      maxlength="4" placeholder="2026" [(ngModel)]="selectedYearS" (ngModelChange)="valasztoValtozott()"></ion-input>
                  </ion-col>
                  <ion-col *ngIf="selectedMonth && selectedMonthS">
                    <div class="honap-lepteto">
                    <ion-button fill="clear" size="small" title="Előző hónap" aria-label="Előző hónap"
                      (click)="honapLep(-1)">
                      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
                    </ion-button>
                    <ion-select fill="outline" interface="popover" label="Tárgyhónap" labelPlacement="stacked"
                      name="selectedMonth" [(ngModel)]="selectedMonthS" (ngModelChange)="valasztoValtozott()"
                      [value]="selectedMonthS"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
                      <ion-select-option value="1">Január</ion-select-option>
                      <ion-select-option value="2">Február</ion-select-option>
                      <ion-select-option value="3">Március</ion-select-option>
                      <ion-select-option value="4">Április</ion-select-option>
                      <ion-select-option value="5">Május</ion-select-option>
                      <ion-select-option value="6">Június</ion-select-option>
                      <ion-select-option value="7">Július</ion-select-option>
                      <ion-select-option value="8">Augusztus</ion-select-option>
                      <ion-select-option value="9">Szeptember</ion-select-option>
                      <ion-select-option value="10">Október</ion-select-option>
                      <ion-select-option value="11">November</ion-select-option>
                      <ion-select-option value="12">December</ion-select-option>
                    </ion-select>
                    <ion-button fill="clear" size="small" title="Következő hónap" aria-label="Következő hónap"
                      (click)="honapLep(1)">
                      <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
                    </ion-button>
                    </div>
                  </ion-col> </ion-row><!--ion-row>
              <ion-col>
                
                  <ion-input fill="outline" labelPlacement="stacked"
                    label="Intézmény"
                    type="text"
                    placeholder="Válasszon intézményt"
                    [value]="sajatIntezmeny.intezmenyName"
                  ></ion-input>
             
              </ion-col>
            </ion-row><ion-row>
              <ion-col>
             <div style="margin-top: 5px;">
                  <ion-button (click)="searchM()">
                    <ion-icon slot="start" name="search"></ion-icon>
                    Keresés
                  </ion-button>
                  <ion-button color="secondary" (click)="resetM()">
                    <ion-icon slot="start" name="refresh"></ion-icon>
                    Visszaállítás
                  </ion-button>
                </div>
              </ion-col>
            </ion-row-->
              </ion-grid>
            </ion-card-content>
          </ion-card>

          <!--  HELYETTESÍTÉSI HETI KEDVEZMÉNY.
                Az eseti helyettesítésből hetente ennyi óra NEM kerül kifizetésre. A
                mérték a kötelező óraszámtól függ (jogszabályi alapeset 0/1/2), de
                intézményi megállapodás eltérhet – tipikusan úgy, hogy mindent
                kifizetnek. Eddig ez be volt drótozva a riport lekérdezésébe. -->
          <ion-card *ngIf="helyKedv">
            <ion-card-header>
              <ion-card-title>Helyettesítési heti kedvezmény</ion-card-title>
              <ion-card-subtitle>
                Az <b>eseti</b> helyettesítésből hetente ennyi óra <b>nem kerül kifizetésre</b>,
                a kötelező óraszám (alapóra + órakedvezmény) szerint lépcsőzve.
                <b>Mindhármat 0-ra állítva minden helyettesítés fizetett.</b>
              </ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <!-- a riport hónapjában érvényes érték – ezt mutatja a kártya -->
              <div class="hkedv-ervenyes">
                A <b>{{ honapNeve(helyKedv.honap) }}i</b> riport ezzel számol:
                <b>{{ helyKedv.kedv_26plus }} / {{ helyKedv.kedv_25 }} / {{ helyKedv.kedv_24 }}</b>
                <span *ngIf="helyKedv.ervenyes_tol">({{ honapTol(helyKedv.ervenyes_tol) }} beállítva)</span>
                <span *ngIf="!helyKedv.ervenyes_tol">(jogszabályi alapérték — erre a hónapra nincs beállítás)</span>
              </div>
              <div class="hkedv-sor">
                <ion-select fill="outline" interface="popover" labelPlacement="stacked" label="Érvényes: év"
                            [(ngModel)]="helyKedvEv">
                  <ion-select-option *ngFor="let e of helyKedvEvek" [value]="e">{{ e }}</ion-select-option>
                </ion-select>
                <ion-select fill="outline" interface="popover" labelPlacement="stacked" label="hónaptól"
                            [(ngModel)]="helyKedvHo">
                  <ion-select-option *ngFor="let n of honapNevek; let i = index" [value]="i + 1">{{ n }}</ion-select-option>
                </ion-select>
                <ion-input type="number" min="0" max="40" fill="outline" labelPlacement="stacked"
                           label="26 óra felett" [(ngModel)]="helyKedv.kedv_26plus"></ion-input>
                <ion-input type="number" min="0" max="40" fill="outline" labelPlacement="stacked"
                           label="pontosan 25" [(ngModel)]="helyKedv.kedv_25"></ion-input>
                <ion-input type="number" min="0" max="40" fill="outline" labelPlacement="stacked"
                           label="24 vagy kevesebb" [(ngModel)]="helyKedv.kedv_24"></ion-input>
                <ion-button size="small" color="success" (click)="helyKedvMentes()" [disabled]="helyKedvFut">
                  <ion-icon slot="start" name="save-outline"></ion-icon>
                  {{ helyKedvFut ? 'Mentés…' : 'Mentés' }}
                </ion-button>
                <ion-button size="small" fill="clear" (click)="helyKedvAlapra()" [disabled]="helyKedvFut">
                  Jogszabályi alapérték (0 / 1 / 2)
                </ion-button>
              </div>
              <div class="hkedv-idoszakok" *ngIf="helyKedv.idoszakok?.length">
                <span class="hkedv-cimke">Beállított időszakok:</span>
                <ion-chip *ngFor="let i of helyKedv.idoszakok" outline="true">
                  <ion-label>{{ honapTol(i.ervenyes_tol) }}: {{ i.kedv_26plus }} / {{ i.kedv_25 }} / {{ i.kedv_24 }}</ion-label>
                  <ion-icon name="close-circle" (click)="helyKedvTorol(i.ervenyes_tol)"
                            title="Időszak törlése" aria-label="Időszak törlése"></ion-icon>
                </ion-chip>
              </div>
              <ion-note color="medium" style="font-size:.8rem; display:block; margin-top:6px">
                A mentés a <b>választott hónaptól</b> érvényes, egészen a következő beállított
                időszakig<span *ngIf="helyKedvKovetkezo"> (itt: {{ honapTol(helyKedvKovetkezo) }} már más érték számít)</span>.
                A <b>korábbi hónapok riportja nem változik</b>; ahol nincs beállítás, ott a jogszabályi alapérték számít.
                <br>Az <b>összevonás</b> ettől függetlenül külön szabály szerint megy: az
                <b>eseti összevonás</b> egyáltalán nem kerül kifizetésre, a <b>tartós összevonás</b>
                pedig <b>fél óradíjjal</b> számít. A kedvezmény átállítása ezen nem változtat.
              </ion-note>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title><span style="vertical-align: -webkit-baseline-middle">Nyilvántartás ({{ munkanapok }}
                  munkanap)</span>
                <ion-button (click)="printData()" style="float: right" size="small" color="light">
                  <ion-icon slot="icon-only" name="print-outline"></ion-icon>
                </ion-button><!--ion-button
                  [href]="environment.n8n+'/webhook/d72ddc7f-df1b-4cdc-b502-38ecf2b8a77f?ev='+selectedYear+'&honap='+selectedMonth+'&intezmeny='+sajatIntezmeny.intezmenyId"
                  download style="float: right" size="small" color="light">
                  <img src="/assets/icon/kettos.png" width="20px">&nbsp;
                  RLB export
                </ion-button-->
                <!--ion-button disabled (click)="printData()" style="float: right" size="small" color="light">
                  <ion-icon slot="start" name="save-outline"></ion-icon>
                  Kompenzációk mentése (WIP)
                </ion-button-->
              </ion-card-title>
            </ion-card-header>

            <ion-card-content>
             
                <ion-select fill="outline" interface="popover" label="Nézet" labelPlacement="stacked"
                  style="padding: 10px" [(ngModel)]="nezet">
                  <ion-select-option value="1" [disabled]="jogkor == 'pedagogus'">Táblázat</ion-select-option>
                  <ion-select-option value="10" [disabled]="jogkor == 'pedagogus'">Táblázat - Bérszámfejtés</ion-select-option>
                  <ion-select-option value="2">Karton (Havi) - ALFA</ion-select-option>
                  <ion-select-option value="3" disabled>Karton (Éves) - ALFA</ion-select-option>
                </ion-select>

                <app-searchable-select (click)="select.open()" *ngIf="nezet == '2' && jogkor != 'pedagogus'" #select
                  title="Munkavállaló kiválasztása" [data]="ports" [placeholderText]="sajatnev"
                  [itemTextField]="'full_name'" (selectedChanged)="selectChanged($event)" theme="new" [multiple]="false"
                  style="cursor: pointer; padding: 10px"></app-searchable-select>

                <div *ngIf="nezet == '2' && selectedPort" style="padding: 10px; display: flex; gap: 8px; flex-wrap: wrap;">
                  <ion-button size="small" color="primary" (click)="downloadKartonPdf(selectedPort)">
                    <ion-icon slot="start" name="download-outline"></ion-icon>
                    Karton letöltése (PDF)
                  </ion-button>
                  <!-- #1068: könyveletlen óra mellett a saját elszámolás zárva (a vezetésnek csak
                       figyelmeztetés); a letiltott gomb nem mutat súgót, ezért a span viseli. -->
                  <span [title]="munkaidoEll?.konyveletlen ? munkaidoEll?.uzenet : ''">
                    <ion-button size="small" [color]="munkaidoEll?.konyveletlen ? 'warning' : 'primary'" fill="outline"
                                [disabled]="munkaidoEll?.tilt" (click)="munkaidoElszamolas(selectedPort?.adid)">
                      <ion-icon slot="start" [name]="munkaidoEll?.konyveletlen ? 'warning-outline' : 'document-text-outline'"></ion-icon>
                      Munkaidő-elszámolás (PDF)
                      <span *ngIf="munkaidoEll?.konyveletlen" style="margin-left:4px; font-size:11px;">({{ munkaidoEll?.konyveletlen }} könyveletlen)</span>
                    </ion-button>
                  </span>
                  <ion-button size="small" color="primary" fill="outline" (click)="munkabajarasNyomtatvany(selectedPort?.adid)">
                    <ion-icon slot="start" name="car-outline"></ion-icon>
                    Munkábajárás nyomtatvány
                  </ion-button>
                  <ion-button size="small" color="secondary" fill="outline" (click)="munkaidoElszamolas('*')" *ngIf="jogkor != 'pedagogus'"
                              [title]="munkaidoEllMind?.konyveletlen ? munkaidoEllMind?.uzenet : ''">
                    <ion-icon slot="start" [name]="munkaidoEllMind?.konyveletlen ? 'warning-outline' : 'documents-outline'"
                              [color]="munkaidoEllMind?.konyveletlen ? 'warning' : undefined"></ion-icon>
                    Mindenki munkaidő-elszámolása (PDF)
                  </ion-button>
                  <ion-button size="small" color="secondary" (click)="downloadAllKartonZip()" *ngIf="jogkor != 'pedagogus'">
                    <ion-icon slot="start" name="archive-outline"></ion-icon>
                    Összes karton letöltése (ZIP)
                  </ion-button>
                  <ion-button size="small" color="tertiary" *ngIf="jogkor != 'pedagogus'"
                              (click)="kikuldesNyit()">
                    <ion-icon slot="start" name="paper-plane-outline"></ion-icon>
                    Kiküldés az iktatóba
                  </ion-button>
                </div>
                <!-- #1068: a könyveletlen órák láthatóan is (a súgót könnyű nem észrevenni). -->
                <div *ngIf="nezet == '2' && selectedPort && (munkaidoEll?.konyveletlen || munkaidoEllMind?.konyveletlen)"
                     style="padding: 0 10px 8px; font-size: 12px; color: var(--ion-color-warning-shade);">
                  <div *ngIf="munkaidoEll?.konyveletlen">
                    <ion-icon name="warning-outline" style="vertical-align: -2px;"></ion-icon> {{ munkaidoEll?.uzenet }}
                  </div>
                  <div *ngIf="munkaidoEllMind?.konyveletlen">
                    <ion-icon name="warning-outline" style="vertical-align: -2px;"></ion-icon> Tantestület: {{ munkaidoEllMind?.uzenet }}
                  </div>
                </div>

                <!-- Bérjegyzék-kiküldés: itt készül a PDF, az iktató pedig aláírja,
                     iktatja és kézbesíti. A számítás egyetlen helyen marad. -->
                <div *ngIf="kikuldesNyitva" class="kikuldes-doboz">
                  <h3>Bérjegyzékek kiküldése – {{ selectedYear }}. {{ selectedMonth }}. hónap</h3>
                  <p class="magyarazat">
                    A kartonokat itt generáljuk (ugyanazt, amit letöltésnél kapsz), az Iktatgató
                    pedig elektronikusan aláírja, kimenő iratként iktatja, és a választott
                    csatornán kézbesíti. Aki nincs a partnertörzsben, azt jelezzük.
                  </p>

                  <div class="kikuldes-sor">
                    <ion-select label="Iktatókönyv" label-placement="stacked" interface="popover"
                                [(ngModel)]="kikuldes.konyv">
                      <ion-select-option *ngFor="let k of iktKonyvek" [value]="k.id">
                        {{ k.jel }} – {{ k.nev }} ({{ k.ev }})
                      </ion-select-option>
                    </ion-select>
                    <ion-select label="Csatorna" label-placement="stacked" interface="popover"
                                [(ngModel)]="kikuldes.csatorna">
                      <ion-select-option value="bksz">BKSZ (hivatali kapu / cégkapu)</ion-select-option>
                      <ion-select-option value="email">E-mail</ion-select-option>
                      <ion-select-option value="papir">Papír (postakönyvbe)</ion-select-option>
                    </ion-select>
                    <ion-select label="Irattári tétel" label-placement="stacked" interface="popover"
                                [(ngModel)]="kikuldes.tetelszam">
                      <ion-select-option value="">– nincs –</ion-select-option>
                      <ion-select-option *ngFor="let t of iktTerv" [value]="t.tetelszam">
                        {{ t.tetelszam }} – {{ t.megnevezes }}
                      </ion-select-option>
                    </ion-select>
                  </div>

                  <div class="kikuldes-sor">
                    <ion-checkbox labelPlacement="end" [checked]="kikuldes.automata"
                                  (ionChange)="kikuldes.automata = $event.detail.checked">
                      Aláírás és iktatás azonnal
                    </ion-checkbox>
                    <ion-button size="small" (click)="kikuldesIndit()"
                                [disabled]="kikuldesFut || !kikuldes.konyv || !kikuldesCimzettek.length">
                      <ion-icon slot="start" name="send-outline"></ion-icon>
                      {{ kikuldesFut ? kikuldesAllapot : ('Indítás (' + kikuldesCimzettek.length + ' fő)') }}
                    </ion-button>
                    <ion-button size="small" fill="clear" (click)="kikuldesNyitva = false">Bezárás</ion-button>
                  </div>

                  <div *ngIf="!iktKonyvek.length" class="magyarazat" style="color:var(--ion-color-danger)">
                    Nincs nyitott iktatókönyv – az Iktatgató → Beállítások → Iktatókönyvek menüben nyiss egyet.
                  </div>

                  <div class="kikuldes-sor" *ngIf="kikuldesLista.length">
                    <ion-searchbar class="kikuldes-kereso" placeholder="Dolgozó keresése" [debounce]="150"
                                   [(ngModel)]="kikuldesSzuro"></ion-searchbar>
                    <ion-button size="small" fill="outline" (click)="kikuldesJelol(true)" [disabled]="kikuldesFut">Mind</ion-button>
                    <ion-button size="small" fill="outline" (click)="kikuldesJelol(false)" [disabled]="kikuldesFut">Senki</ion-button>
                    <span class="magyarazat">{{ kikuldesCimzettek.length }} kijelölve — egy emberre is indítható</span>
                  </div>

                  <div class="kikuldes-tabla" *ngIf="kikuldesLista.length">
                    <table>
                      <thead><tr><th></th><th>Dolgozó</th><th>Kézbesíthetőség</th><th>Állapot</th></tr></thead>
                      <tbody>
                        <tr *ngFor="let s of kikuldesLathato" [class.kikuldes-nem-jelolt]="s.kivalaszthato && !s.kijelolve">
                          <td>
                            <ion-checkbox *ngIf="s.kivalaszthato" [checked]="s.kijelolve" [disabled]="kikuldesFut"
                                          (ionChange)="s.kijelolve = $event.detail.checked"
                                          [attr.aria-label]="s.nev + ' kijelölése'"></ion-checkbox>
                          </td>
                          <td>{{ s.nev }}</td>
                          <td>
                            <span *ngIf="!s.gond" class="ok">rendben</span>
                            <span *ngIf="s.gond" class="figyelem">{{ s.gond }}</span>
                          </td>
                          <td>
                            <span *ngIf="s.allapot" [class.hiba]="s.hiba">{{ s.hiba || s.allapot }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div *ngIf="kikuldesEredmeny" class="magyarazat">
                    <b>{{ kikuldesEredmeny }}</b>
                  </div>
                </div>
             
              <div style="text-align: center" id="magyarazat">
                <ion-chip>
                  <ion-icon name="alert" color="danger"></ion-icon>
                  <ion-label>Nincs adat</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="bed" color="tertiary"></ion-icon>
                  <ion-label>Fizetett szabadság</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="medkit" color="warning"></ion-icon>
                  <ion-label>Betegszabadság / táppénz</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="globe" color="secondary"></ion-icon>
                  <ion-label>Digitális távoktatás / Home Office</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="car" color="secondary"></ion-icon>
                  <ion-label>Iskolai kiküldetés</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="ban" color="dark"></ion-icon>
                  <ion-label>Fizetés nélküli szabadság</ion-label>
                </ion-chip>
                <ion-chip>
                  <ion-icon name="leaf" color="success"></ion-icon>
                  <ion-label>Nincs tanítási órám / Egyéb mentesülés</ion-label>
                </ion-chip>
              </div>

              <!--a-- href="javascript:void(0);" (click)="printUrl('/print?minimize=1')">nyomtatás</a-->
              <!--a href="javascript:void(0);" (click)="printData()">nyomtatás</a>
  <b>FEJLESZTÉS ALATT, ALPHA VÁLTOZAT</b-->
              <div class="scrollable-table1 printable table-wrap" *ngIf="nezet == '1'">
                <table id="printable" class="sticky-table" *ngIf="tanorak">
                  <thead>
                    <tr>
                      <!--th>#</th-->
                      <th class="sticky-col">Munkavállaló</th>
                      <th>#</th>
                      <th *ngFor="
                          let c of [].constructor(daysInMonth.length);
                          let idx = index
                        ">
                        {{ ("0" + (idx + 1)).slice(-2) }}
                      </th>
                      <th>{{ replaceAccentedChars("óra") }}</th>
                      <th>{{ replaceAccentedChars("Helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Szab.") }}</th>
                      <th>{{ replaceAccentedChars("Betegá.") }}</th>
                      <th>{{ replaceAccentedChars("Alapbér") }}</th>
                      <th>{{ replaceAccentedChars("Pótlék") }}</th>
                      <th>{{ replaceAccentedChars("Táv.díj") }}</th>
                      <th>{{ replaceAccentedChars("Beteg.díj") }}</th>
                      <th>{{ replaceAccentedChars("Megb.díj") }}</th>
                      <th title="Nem szakos órák díja: a tantárgyfelosztása szerint nem az ő szakjából tartott órák, külön óradíjon">{{ replaceAccentedChars("Nem szakos") }}</th>
                      <th>{{ replaceAccentedChars("Eseti helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Tart.helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Köt.túlóra") }}</th>
                      <th>{{ replaceAccentedChars("Kik.rend.") }}</th>
                      <th title="Jóváhagyott bérlet-térítés (a dolgozó adja be a számlával)">{{ replaceAccentedChars("Bérlet") }}</th>
                      <th title="Óra alapú kompenzáció (óra × óradíj)">{{ replaceAccentedChars("Óra alapú") }}</th>
                      <th title="Egyéb jóváhagyott kompenzáció (és a régi, kézzel rögzített összeg)">{{ replaceAccentedChars("Egyéb komp.") }}</th>
                      <th title="Alapbér + pótlék + betegszabadság + megbízási díj + túlóra/helyettesítés + kompenzáció (km-térítés nélkül)">
                        {{ replaceAccentedChars("Bruttó összesen") }}
                      </th>
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let user of ports; let i = index">
                      <tr>
                        <!--td
        style="text-align: center; font-size: 25px; padding: 0"
        rowspan="3"
      >
        <!--ion-button-- color="primary" (click)="printdiv('printable')">
          <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
        </ion-button>
      </td-->
                        <th rowspan="4" class="sticky-col">
                          {{ replaceAccentedChars(user.viselt_vez) }}
                          {{ replaceAccentedChars(user.viselt_ker) }}
                        </th>
                        <!--ng-container *ngIf="user.intezmenyfilter.munkaviszony!='1'">
                          <td rowspan="4" [attr.colspan]="daysInMonth.length+1">
                            MEGBÍZÁSI MUNKAVISZONY
                          </td>
                        </ng-container-->
                        <td>Érk.</td>
                        <ng-container *ngFor="let v of user.nyilv; let id = index">
                          <td rowspan="4" *ngIf="v == 1 || v == 2" style="background-color: lightgray">
                            &nbsp;&nbsp;
                          </td>
                          <td rowspan="4" *ngIf="v == 0">
                            <ion-icon name="alert-outline"></ion-icon>
                          </td>

                          <ng-container *ngIf="v != 0 && v != 1 && v != 2">
                            <td class="rotate" *ngIf="v.status == 1">
                              <div>
                                <small>
                                  {{
                                  ("0" + napKer(v.start).hours()).slice(-2)
                                  }}:{{
                                  ("0" + napKer(v.start).minutes()).slice(-2)
                                  }}
                                </small>
                              </div>
                            </td>
                            <td rowspan="4" *ngIf="v.status == 2">
                              <ion-icon name="bed-outline"></ion-icon>
                            </td>
                            <td rowspan="4" *ngIf="v.status == 3 && user.fizNelkuli">
                              <ion-icon name="medkit-outline"></ion-icon> T
                            </td>
                            <td rowspan="4" *ngIf="v.status == 3 && !user.fizNelkuli">
                              <ion-icon name="medkit-outline"></ion-icon>
                            </td>
                            <!--td rowspan="4" *ngIf="v.status == 7">
            <ion-icon name="globe-outline"></ion-icon>
          </td-->
                            <td class="rotate" *ngIf="v.status == 7">
                              <div>
                                <small>
                                  {{
                                  ("0" + napKer(v.start).hours()).slice(-2)
                                  }}:{{
                                  ("0" + napKer(v.start).minutes()).slice(-2)
                                  }}
                                </small>
                              </div>
                            </td>
                            <!--td rowspan="4" *ngIf="v.status == 4">
            <ion-icon name="car-outline"></ion-icon>
          </td-->
                            <td class="rotate" *ngIf="v.status == 4">
                              <div>
                                <small>
                                  {{
                                  ("0" + napKer(v.start).hours()).slice(-2)
                                  }}:{{
                                  ("0" + napKer(v.start).minutes()).slice(-2)
                                  }}
                                </small>
                              </div>
                            </td>
                            <td rowspan="4" *ngIf="v.status == 5">
                              <ion-icon name="ban-outline"></ion-icon>
                            </td>
                            <td rowspan="4" *ngIf="v.status == 6">
                              <ion-icon name="leaf-outline"></ion-icon>
                            </td>
                          </ng-container>

                          <!--td class="rotate" *ngFor="let c of [].constructor(31); let id = index">
        <div *ngFor="let v of item.nyilv">
          <small *ngIf="napKer(v.start).getDay() == id+1">
          {{("0" + napKer(v.start).getHours()).slice(-2)}}:{{("0" + napKer(v.start).getMinutes()).slice(-2)}}
          </small>
        </div>
        <div *ngIf='isWeekend(selectedYear + "-" + selectedMonth + "-" + (id+1))' style="background-color:grey">

        </div>
      </td>
      <td rowspan="3"
        style="
                          background-color: var(--ion-color-tertiary-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        "
      >
        <ion-icon name="bed-outline"></ion-icon>
      </td>
      <td rowspan="3"
          style="
                          background-color: var(--ion-color-warning-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        "
      >
        <ion-icon name="medkit-outline"></ion-icon>
      </td>
      <td rowspan="3"
          style="
                          background-color: var(--ion-color-secondary-shade);
                          text-align: center;
                          font-size: 25px;
                          padding: 0;
                          color: white;
                        "
      >
        <ion-icon name="car-outline"></ion-icon>
      </td-->
                        </ng-container>


                        <td rowspan="4" class="rotate1">
                          {{ parseFloat(user.osszora || 0).toFixed(0) }} /
                          {{
                          tanorak && tanorak[user.adid]
                          ? parseFloat(tanorak[user.adid]?.db || 0).toFixed(
                          0
                          )
                          : "-"
                          }}
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="helyettesitesek && helyettesitesek[user.adid]">
                          {{ helyettesitesek[user.adid]?.eseti_total || 0 }}/{{
                          helyettesitesek[user.adid]?.tartos || 0
                          }}/{{
                          helyettesitesek[user.adid]?.szivessegi || 0
                          }}/{{ helyettesitesek[user.adid]?.tulora_count || 0 }}
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="
                            !helyettesitesek || !helyettesitesek[user.adid]
                          ">
                          N/A
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="szabadsag && szabadsag[user.adid]">
                          {{ szabadsag[user.adid]?.szabadsag }}/{{
                          szabadsagRiportFelhasznalt(szabadsag[user.adid])
                          }}({{
                          szabadsag[user.adid]
                          ?.honapban_felhasznalt_szabadsag
                          }})/{{
                          szabadsagRiportMaradt(szabadsag[user.adid])
                          }}
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="!szabadsag || !szabadsag[user.adid]">
                          N/A
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="szabadsag && szabadsag[user.adid]">
                          {{ szabadsag[user.adid]?.tappenz }}/{{
                          tappenzRiportFelhasznalt(szabadsag[user.adid])
                          }}({{
                          szabadsag[user.adid]
                          ?.honapban_felhasznalt_tappenz
                          }})/{{
                          tappenzRiportMaradt(szabadsag[user.adid])
                          }}
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="!szabadsag || !szabadsag[user.adid]">
                          N/A
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "alapber") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1" [title]="potlekCimke(user)">
                          {{
                          berSzamolas(user, "potlek") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "tavdij") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "betegdij") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "megbizasi") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1"
                            [title]="nemszakosOradij(user) ? (oraszamok(user).nemszakos + ' nem szakos óra × ' + nemszakosOradij(user) + ' Ft') : 'Nincs megadva nem szakos óradíj'">
                          {{
                          berSzamolas(user, "nemszakos") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "eseti") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "tartos") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1">
                          {{
                          berSzamolas(user, "tulora") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="
                            utazas && utazas[user.adid] && utazas[user.adid].km
                          ">
                          {{
                          (
                          utazas[user.adid].km * utazas[user.adid].munkanap
                          ).toFixed(0)
                          }}
                          km<br />{{
                          (
                          utazas[user.adid].km *
                          utazas[user.adid].munkanap *
                          utazas[user.adid].benzinpenz
                          ).toFixed(0) || 0 | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td rowspan="4" class="rotate1" *ngIf="
                            !utazas ||
                            !utazas[user.adid] ||
                            !utazas[user.adid].km
                          ">
                          N/A
                        </td>
                        <!-- Bérlet: a munkatárs adja be a számlával, admin hagyja jóvá -->
                        <td rowspan="4" class="rotate1">
                          {{ berletFt(user) | currency : "HUF" : "" : "0.0" }} Ft
                          <div *ngIf="varakozoTetel(user)" style="color:#c80;font-size:11px">
                            {{varakozoTetel(user)}} elbírálásra vár
                          </div>
                        </td>
                        <!-- Óra alapú kompenzáció: órák × a teljes bérből számolt óradíj -->
                        <td rowspan="4" class="rotate1">
                          {{ oraKompFt(user) | currency : "HUF" : "" : "0.0" }} Ft
                          <div>
                            <ion-button size="small" fill="clear" color="primary" (click)="oraKompenzacio(user)"
                              title="Óra alapú kompenzáció rögzítése (pl. túlóra)">
                              <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
                            </ion-button>
                          </div>
                        </td>
                        <!-- Egyéb kompenzáció. A kézi beviteli mező KIKERÜLT: sosem lehetett
                             elmenteni (a mentés gombja évek óta ki volt kommentelve), tehát aki
                             beírt egy számot, azt látta a bruttóban, kinyomtatta – újratöltésnél
                             pedig nyoma sem maradt. A kompenzációt a Bérlet / kompenzáció modul
                             kezeli, tételesen, elbírálással. A RÉGI, már rögzített összegek
                             továbbra is beleszámítanak: a lezárt hónapok bére nem változhat. -->
                        <td rowspan="4" class="rotate1">
                          {{ kompEgyebFt(user) | currency : "HUF" : "" : "0.0" }} Ft
                          <div>
                            <ion-button size="small" fill="clear" color="primary" (click)="egyebKompenzacio(user)"
                              title="Egyéb kompenzáció rögzítése (a régi kézi mező helyett – ez el is mentődik)">
                              <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
                            </ion-button>
                          </div>
                        </td>
                        <td rowspan="4" class="rotate1 brutto-ossz">
                          {{
                          bruttoOsszesen(user) || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                      </tr>


                      <tr>
                        <td>Táv.</td>

                        <ng-container *ngFor="let v of user.nyilv">
                          <ng-container *ngIf="v != 0 && v != 1">
                            <td class="rotate" *ngIf="
                                v.status == 1 || v.status == 4 || v.status == 7
                              ">
                              <div>
                                <small>
                                  {{
                                  napKer(v.end).hours() != 0
                                  ? ("0" + napKer(v.end).hours()).slice(-2)
                                  : "-"
                                  }}:{{
                                  napKer(v.end).hours() != 0
                                  ? ("0" + napKer(v.end).minutes()).slice(
                                  -2
                                  )
                                  : "-"
                                  }}
                                </small>
                              </div>
                            </td>
                          </ng-container>
                        </ng-container>

                        <!--td class="rotate" *ngFor="let c of [].constructor(28); let id = index"><div *ngFor="let v of item.nyilv"><small *ngIf="napKer(v.end).getDay() == id+1">{{("0" + napKer(v.end).getHours()).slice(-2)}}:{{("0" + napKer(v.end).getMinutes()).slice(-2)}}</small></div></td-->
                      </tr>
                      <tr>
                        <td>{{ replaceAccentedChars("∑(óra)") }}</td>

                        <ng-container *ngFor="let v of user.nyilv">
                          <ng-container *ngIf="v != 0 && v != 1">
                            <td class="rotate1" *ngIf="
                                v.status == 1 || v.status == 4 || v.status == 7
                              ">
                              <div>
                                <small>
                                  {{
                                  napKer(v.end).hours() != 0
                                  ? napOra(v.start, v.end).toFixed(0)
                                  : "N/A"
                                  }}
                                </small>
                              </div>
                            </td>
                          </ng-container>
                        </ng-container>

                        <!--td class="rotate" *ngFor="let c of [].constructor(28); let id = index"><div *ngFor="let v of item.nyilv"><small *ngIf="napKer(v.end).getDay() == id+1">{{("0" + napKer(v.end).getHours()).slice(-2)}}:{{("0" + napKer(v.end).getMinutes()).slice(-2)}}</small></div></td-->
                      </tr>
                      <tr>
                        <td>{{ replaceAccentedChars("Helyett.") }}</td>

                        <ng-container *ngFor="let v of user.nyilv">
                          <ng-container *ngIf="v != 0 && v != 1">
                            <td class="rotate1" *ngIf="v.status == 1">
                              <div>
                                <small>
                                  {{ v.helyettesites || 0 }}/{{
                                  v.tartos || 0
                                  }}/{{ v.szivessegi || 0 }}
                                </small>
                              </div>
                            </td>
                            <td *ngIf="v.status == 4">
                              <ion-icon name="car-outline"></ion-icon>
                            </td>
                            <td *ngIf="v.status == 7">
                              <ion-icon name="globe-outline"></ion-icon>
                            </td>
                          </ng-container>
                        </ng-container>

                        <!--td class="rotate" *ngFor="let c of [].constructor(28); let id = index"><div *ngFor="let v of item.nyilv"><small *ngIf="napKer(v.end).getDay() == id+1">{{("0" + napKer(v.end).getHours()).slice(-2)}}:{{("0" + napKer(v.end).getMinutes()).slice(-2)}}</small></div></td-->
                      </tr>

                    </ng-container>

                    <!--tr style="border-top: 5px solid">
                      <td>ÖSSZESEN:</td>
                      <td colspan=""></td>
                      <td>1</td>
                    </tr-->
                  </tbody>
                </table>
              </div>
              <!--NÉZET 10 #####################################################################################-->
              <div class="scrollable-table1 printable table-wrap" *ngIf="nezet == '10'">
                <table id="printable10" class="sticky-table" *ngIf="tanorak">
                  <thead>
                    <tr>
                      <!--th>#</th-->
                      <th class="sticky-col">Munkavállaló</th>
                      <th>{{ replaceAccentedChars("óra") }}</th>
                      <th>{{ replaceAccentedChars("Helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Szab.") }}</th>
                      <th>{{ replaceAccentedChars("Betegá.") }}</th>
                      <th>{{ replaceAccentedChars("Alapbér") }}</th>
                      <th>{{ replaceAccentedChars("Pótlék") }}</th>
                      <th>{{ replaceAccentedChars("Táv.díj") }}</th>
                      <th>{{ replaceAccentedChars("Beteg.díj") }}</th>
                      <th>{{ replaceAccentedChars("Eseti díj") }}</th>
                      <th>{{ replaceAccentedChars("Tart.díj") }}</th>
                      <th>{{ replaceAccentedChars("Megb.díj") }}</th>
                      <th title="Nem szakos órák díja: a tantárgyfelosztása szerint nem az ő szakjából tartott órák, külön óradíjon">{{ replaceAccentedChars("Nem szakos") }}</th>
                      <th>{{ replaceAccentedChars("Eseti helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Tart.helyett.") }}</th>
                      <th>{{ replaceAccentedChars("Köt.túlóra") }}</th>
                      <th>{{ replaceAccentedChars("Kik.rend.") }}</th>
                      <th title="Jóváhagyott bérlet + óra alapú + egyéb kompenzáció">{{ replaceAccentedChars("Komp.") }}</th>
                      <th title="Alapbér + pótlék + betegszabadság + megbízási díj + túlóra/helyettesítés + kompenzáció (km-térítés nélkül)">
                        {{ replaceAccentedChars("Bruttó összesen") }}
                      </th>
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let user of ports; let i = index">
                      <tr>
                        <th class="sticky-col">
                          {{ replaceAccentedChars(user.viselt_vez) }}
                          {{ replaceAccentedChars(user.viselt_ker) }}
                        </th>


                        <td class="rotate1">
                          {{ parseFloat(user.osszora || 0).toFixed(0) }} /
                          {{
                          tanorak && tanorak[user.adid]
                          ? parseFloat(tanorak[user.adid]?.db || 0).toFixed(
                          0
                          )
                          : "-"
                          }}
                        </td>
                        <td class="rotate1" *ngIf="helyettesitesek && helyettesitesek[user.adid]">
                          {{ helyettesitesek[user.adid]?.eseti_total || 0 }}/{{
                          helyettesitesek[user.adid]?.tartos || 0
                          }}/{{
                          helyettesitesek[user.adid]?.szivessegi || 0
                          }}/{{ helyettesitesek[user.adid]?.tulora_count || 0 }}
                        </td>
                        <td class="rotate1" *ngIf="
                            !helyettesitesek || !helyettesitesek[user.adid]
                          ">
                          N/A
                        </td>
                        <td class="rotate1" *ngIf="szabadsag && szabadsag[user.adid]">
                          {{ szabadsag[user.adid]?.szabadsag }}/{{
                          szabadsagRiportFelhasznalt(szabadsag[user.adid])
                          }}({{
                          szabadsag[user.adid]
                          ?.honapban_felhasznalt_szabadsag
                          }})/{{
                          szabadsagRiportMaradt(szabadsag[user.adid])
                          }}
                        </td>
                        <td class="rotate1" *ngIf="!szabadsag || !szabadsag[user.adid]">
                          N/A
                        </td>
                        <td class="rotate1" *ngIf="szabadsag && szabadsag[user.adid]">
                          {{ szabadsag[user.adid]?.tappenz }}/{{
                          tappenzRiportFelhasznalt(szabadsag[user.adid])
                          }}({{
                          szabadsag[user.adid]
                          ?.honapban_felhasznalt_tappenz
                          }})/{{
                          tappenzRiportMaradt(szabadsag[user.adid])
                          }}
                        </td>
                        <td class="rotate1" *ngIf="!szabadsag || !szabadsag[user.adid]">
                          N/A
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "alapber") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1" [title]="potlekCimke(user)">
                          {{
                          berSzamolas(user, "potlek") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "tavdij") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "betegdij") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          user.intezmenyfilter.eseti_felulir || user.intezmenyfilter.tulorapenz
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          user.intezmenyfilter.tartos_felulir || user.intezmenyfilter.tartostulorapenz
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "megbizasi") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1"
                            [title]="nemszakosOradij(user) ? (oraszamok(user).nemszakos + ' nem szakos óra × ' + nemszakosOradij(user) + ' Ft') : 'Nincs megadva nem szakos óradíj'">
                          {{
                          berSzamolas(user, "nemszakos") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "eseti") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "tartos") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1">
                          {{
                          berSzamolas(user, "tulora") || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1" *ngIf="
                            utazas && utazas[user.adid] && utazas[user.adid].km
                          ">
                          {{
                          (
                          utazas[user.adid].km * utazas[user.adid].munkanap
                          ).toFixed(0)
                          }}
                          km<br />{{
                          (
                          utazas[user.adid].km *
                          utazas[user.adid].munkanap *
                          utazas[user.adid].benzinpenz
                          ).toFixed(0) || 0 | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                        <td class="rotate1" *ngIf="
                            !utazas ||
                            !utazas[user.adid] ||
                            !utazas[user.adid].km
                          ">
                          N/A
                        </td>
                        <!-- ITT eddig CSAK a régi, kézi összeg látszott, a jóváhagyott
                             bérlet- és óra alapú tételek nem – azok viszont benne voltak a
                             bruttóban. Innen jött a „0 Ft kompenzáció, mégis stimmel a
                             bruttó". Most a teljes kompenzációt mutatja. -->
                        <td class="rotate1" [title]="kompReszletezes(user)">
                          {{ kompOsszesen(user) | currency : "HUF" : "" : "0.0" }} Ft
                        </td>
                        <td class="rotate1 brutto-ossz">
                          {{
                          bruttoOsszesen(user) || 0
                          | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                      </tr>



                    </ng-container>

                    <!--tr style="border-top: 5px solid">
                      <td>ÖSSZESEN:</td>
                      <td colspan=""></td>
                      <td>1</td>
                    </tr-->
                  </tbody>
                </table>
              </div>
              <!--NÉZET 2 #####################################################################################-->

              <ion-grid *ngIf="nezet == '2'">
                <ion-row>
                  <ion-col>
                    <div class="calendar">
                      <!-- Month and Year Header -->
                      <div class="calendar-header">
                        {{ selectedYear }}-{{ selectedMonth }}
                      </div>

                      <!-- Days of the Week -->
                      <div class="calendar-days">
                        <div>Hé</div>
                        <div>Ke</div>
                        <div>Sze</div>
                        <div>Cs</div>
                        <div>Pé</div>
                        <div>Szo</div>
                        <div>Va</div>
                      </div>

                      <!-- Calendar Dates -->
                      <div class="calendar-dates" *ngIf="elsonap > -1">
                        <!-- Blank spaces for days before the month starts on Friday -->
                        <div class="nodate" *ngFor="let a of [].constructor(elsonap == 0 ? 6 : elsonap - 1)"></div>
                        <!--div *ngFor="let _ of [].constructor(honapnapok); let i = index">{{i+1}}</div-->
                        <div *ngFor="let b of selectedPort.nyilv; let i = index" [class]="
                            b == 1 || b == 2 ? 'nodate' : 'cald-' + b.status
                          ">
                          {{ i + 1 }}<br />
                          <ion-icon *ngIf="b.status == 1" name="briefcase"></ion-icon>
                          <ion-icon *ngIf="!b.status && b != 1 && b != 2" name="alert" color="danger"></ion-icon>
                          <ion-icon *ngIf="b.status == 2" name="bed" color=""></ion-icon>
                          <ion-icon *ngIf="b.status == 3" name="medkit" color=""></ion-icon>
                          <ion-icon *ngIf="b.status == 7" name="globe" color=""></ion-icon>
                          <ion-icon *ngIf="b.status == 4" name="car" color=""></ion-icon>
                          <ion-icon *ngIf="b.status == 5" name="ban" color=""></ion-icon>
                          <ion-icon *ngIf="b.status == 6" name="leaf" color=""></ion-icon>
                        </div>
                        <div class="nodate" *ngFor="
                            let a of [].constructor(
                              daysInMonth.length == 31
                                ? 4 - (elsonap - 1)
                                : 5 - (daysInMonth.length <30 ? daysInMonth.length-29+5 : elsonap - 1)
                            )
                          "></div>
                      </div>
                    </div>

                    <ion-list [inset]="true">
                      <ion-item [button]="true" (click)="openComponent()">
                        <ion-icon color="primary" slot="start" name="list" size="large"></ion-icon>
                        <ion-label>Eseti helyettesítések</ion-label>
                        <span slot="end">{{
                          countHelyettesites(selectedPort, "eseti")
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true" (click)="openComponent()">
                        <ion-icon color="primary" slot="start" name="options" size="large"></ion-icon>
                        <ion-label>Tartós helyettesítés</ion-label>
                        <span slot="end">{{
                          countHelyettesites(selectedPort, "tartos")
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true" (click)="openComponent()">
                        <ion-icon color="primary" slot="start" name="options" size="large"></ion-icon>
                        <ion-label>Szívességi helyettesítés</ion-label>
                        <span slot="end">{{
                          countHelyettesites(selectedPort, "szivessegi")
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true" (click)="openComponent()">
                        <ion-icon color="primary" slot="start" name="options" size="large"></ion-icon>
                        <ion-label>Túlóra (TTF)</ion-label>
                        <span slot="end">{{
                          countHelyettesites(selectedPort, "tulora")
                          }}</span>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                  <ion-col>
                    <ion-input fill="outline" labelPlacement="stacked" label="Alapbér" type="text" placeholder=""
                      readonly [value]="
                        (berSzamolas(selectedPort, 'alapber') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    <ion-input fill="outline" labelPlacement="stacked" label="Pótlékok" type="text" placeholder=""
                      readonly [title]="potlekCimke(selectedPort)" [value]="
                        (berSzamolas(selectedPort, 'potlek') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input>
                    <ion-note color="medium" style="display:block;font-size:12px;margin:2px 0 8px">
                      {{ potlekCimke(selectedPort) || 'Nincs pótlék rögzítve.' }}
                    </ion-note>

                    <ion-input fill="outline" labelPlacement="stacked" label="Utazás térítése" type="text" readonly
                      placeholder="" [value]="
                        ((utazasTeritesFt(selectedPort) || 0)
                          | currency : 'HUF' : '' : '0.0') +
                        ' Ft'
                      "></ion-input><br />

                   

                    <ion-input fill="outline" labelPlacement="stacked" label="Eseti helyettesítés" type="text" readonly
                      placeholder="" [value]="
                        (berSzamolas(selectedPort, 'eseti') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    <ion-input fill="outline" labelPlacement="stacked" label="Tartós helyettesítés" type="text" readonly
                      placeholder="" [value]="
                        (berSzamolas(selectedPort, 'tartos') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    

                      <ion-input fill="outline" labelPlacement="stacked" label="Kötött túlóra" type="text" readonly
                      placeholder="" [value]="
                        (berSzamolas(selectedPort, 'tulora') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    <ion-input fill="outline" labelPlacement="stacked" label="Összes túlóra" type="text" readonly
                      placeholder="" [value]="
                        ((osszesTuloraFt(selectedPort) || 0)
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    <ion-input fill="outline" labelPlacement="stacked" label="Fizetett távollét" type="text"
                      placeholder="" readonly [value]="
                        (berSzamolas(selectedPort, 'tavdij') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />
                    <ion-input fill="outline" labelPlacement="stacked" label="Betegszabadság" type="text" readonly
                      placeholder="" [value]="
                        (berSzamolas(selectedPort, 'betegdij') || 0
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />

                    <!-- A kompenzáció benne van a teljes bruttóban, tehát látszódnia is kell:
                         enélkül a panel tételei nem adják ki a végösszeget. -->
                    <ion-input fill="outline" labelPlacement="stacked" label="Kompenzáció" type="text" readonly
                      [title]="kompReszletezes(selectedPort)" placeholder="" [value]="
                        ((kompOsszesen(selectedPort) || 0)
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />
                    <ion-input class="brutto-ossz-mezo" fill="outline" labelPlacement="stacked"
                      label="Teljes bruttó bér" type="text" readonly placeholder="" [value]="
                        ((bruttoOsszesen(selectedPort) || 0)
                          | currency : 'HUF' : '' : '0.0') + ' Ft'
                      "></ion-input><br />
                    <!--ion-input fill="outline" labelPlacement="stacked" label="Táppénz" type="text" readonly
                      placeholder="" [value]="
                        '- Ft (WIP)'
                      "></ion-input><br />
                    <ion-input fill="outline" labelPlacement="stacked" label="Levonandó járulékok" type="text" readonly
                      placeholder="" [value]="
                        '- Ft (WIP)'
                      "></ion-input><br />
                    <ion-input fill="outline" labelPlacement="stacked" label="Letiltások" type="text" readonly
                      placeholder="" [value]="
                        '- Ft (WIP)'
                      "></ion-input><br />
                    <ion-input fill="outline" labelPlacement="stacked" label="Fizetendő jövedelem" type="text" readonly
                      placeholder="" [value]="
                        '- Ft (WIP)'
                      "></ion-input><br /-->
                  </ion-col>
                  <ion-col>
                    <ion-list [inset]="true">
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="list-circle" size="large"></ion-icon>
                        <ion-label>Tárgyhavi munkanapok</ion-label>
                        <span slot="end">{{ munkanapok }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="briefcase" size="large"></ion-icon>
                        <ion-label>Ledolgozott munkanapok</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 1) +
                          countNapType(selectedPort, 4) +
                          countNapType(selectedPort, 6) +
                          countNapType(selectedPort, 7)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="globe" size="large"></ion-icon>
                        <ion-label>Ebből home office</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 7)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="car" size="large"></ion-icon>
                        <ion-label>Ebből kiküldetés</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 4)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="leaf" size="large"></ion-icon>
                        <ion-label>Ebből egyéb mentesülés</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 6)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="bed" size="large"></ion-icon>
                        <ion-label>Kivett szabadság</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 2)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="medkit" size="large"></ion-icon>
                        <ion-label>Betegszabadság</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 3)
                          }}</span>
                      </ion-item>
                      <ion-item [button]="true">
                        <ion-icon color="primary" slot="start" name="ban" size="large"></ion-icon>
                        <ion-label>Fizetés nélküli szabadság</ion-label>
                        <span slot="end">{{
                          countNapType(selectedPort, 5)
                          }}</span>
                      </ion-item>
                    </ion-list>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid *ngIf="jogkor != 'pedagogus'">
      <ion-row>
        <ion-col>
          <ion-card>
            <ion-card-header>
              <ion-card-title><span style="vertical-align: -webkit-baseline-middle">Munkábajárás</span>
                <ion-button (click)="printData2()" style="float: right" size="small" color="light">
                  <ion-icon slot="icon-only" name="print-outline"></ion-icon>
                </ion-button>
              </ion-card-title>
            </ion-card-header>

            <ion-card-content>
              <p class="munkabajaras-sugo">
                <ion-icon name="print-outline"></ion-icon>
                A dolgozó A4-es, aláírandó nyomtatványához kattints a nevére. A jobb felső gomb az összesítőt nyomtatja.
              </p>
              <!--a-- href="javascript:void(0);" (click)="printUrl('/print?minimize=1')">nyomtatás</a-->
              <!--a href="javascript:void(0);" (click)="printData()">nyomtatás</a>
  <b>FEJLESZTÉS ALATT, ALPHA VÁLTOZAT</b-->
              <div class="scrollable-table">
                <table id="printable2">
                  <thead>
                    <tr>
                      <!--th>#</th-->
                      <th>Munkavállaló</th>

                      <th *ngFor="
                          let c of [].constructor(daysInMonth.length);
                          let idx = index
                        ">
                        {{ ("0" + (idx + 1)).slice(-2) }}
                      </th>
                      <th>{{ replaceAccentedChars("∑(Kik.rend.)") }}</th>
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let user of ports; let i = index">
                      <tr *ngIf="
                          utazas && utazas[user.adid] && utazas[user.adid].km
                        ">
                        <!--td
        style="text-align: center; font-size: 25px; padding: 0"
        rowspan="3"
      >
        <!--ion-button-- color="primary" (click)="printdiv('printable')">
          <ion-icon slot="icon-only" name="ellipsis-horizontal"></ion-icon>
        </ion-button>
      </td-->
                        <!--  A név egyben a dolgozó A4-es, aláírandó nyomtatványának gombja. Az
                              összesítő PDF a cella SZÖVEGÉT viszi át, ezért az ikon nem kerül bele. -->
                        <td rowspan="1" class="munkabajaras-nev" (click)="munkabajarasNyomtatvany(user.adid)"
                          title="A4-es munkábajárás-nyomtatvány (aláírásra)">
                          {{ replaceAccentedChars(user.viselt_vez) }}
                          {{ replaceAccentedChars(user.viselt_ker) }}
                          <ion-icon name="print-outline"></ion-icon>
                        </td>

                        <ng-container *ngFor="let v of user.nyilv; let id = index">
                          <td rowspan="1" *ngIf="v == 1 || v == 2" style="background-color: lightgray">
                            &nbsp;&nbsp;
                          </td>
                          <td rowspan="1" *ngIf="v == 0">
                            <ion-icon name="alert-outline"></ion-icon>
                          </td>

                          <ng-container *ngIf="v != 0 && v != 1 && v != 2">
                            <td class="rotate1" *ngIf="v.status == 1">
                              <div>{{ utazas[user.adid].km }} km</div>
                            </td>
                            <td rowspan="1" *ngIf="v.status != 1">
                              <ion-icon name="ban-outline"></ion-icon>
                            </td>
                          </ng-container>
                        </ng-container>
                        <td rowspan="1">
                          {{
                          (
                          utazas[user.adid].km * utazas[user.adid].munkanap
                          ).toFixed(0)
                          }}
                          km<br />{{
                          (
                          utazas[user.adid].km *
                          utazas[user.adid].munkanap *
                          utazas[user.adid].benzinpenz
                          ).toFixed(0) || 0 | currency : "HUF" : "" : "0.0"
                          }}
                          Ft
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <ion-modal class="" style="z-index: 1000" #tetelmodal trigger="tetel">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="close()">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Részletes adatok</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" style="margin: auto">Fejlesztés alatt! </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
